import styled from 'styled-components';

import SvgIcon from '~src/shared/SvgIcon';

export const ItemMenuContainer = styled.div`
  margin: -12px -16px;
  position: relative;
  z-index: 9;
  border-radius: 4px;
  overflow: hidden;
  min-width: 210px;

  > div:last-child {
    border: 0;
  }
`;

export const MenuItem = styled.div`
  font-size: 1rem;
  text-transform: capitalize;
  padding: 15px;
  color: ${({ theme }) => theme.baseBlue.a6};
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.black.a1};

  svg {
    color: ${({ theme }) => theme.baseBlue.a6};
  }

  &:hover {
    background-color: ${({ theme }) => theme.baseBlue.a10};
    color: ${({ theme }) => theme.white.a10};

    svg {
      color: ${({ theme }) => theme.white.a10};
    }
  }
`;

export const MenuItemDel = styled(MenuItem)`
  &:hover {
    background-color: ${({ theme }) => theme.red.a10};
  }
`;

export const NoDeletionMessage = styled.div`
  width: 100%;
  font-size: 1rem;
  font-weight: 300;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.4rem;
  color: ${({ theme }) => theme.baseBlue.a6};

  span {
    white-space: nowrap;
  }
`;

export const FrameworkBox = styled.div`
  font-size: 0.8rem;
  padding: 6px 8px;
  font-weight: 600;
  letter-spacing: 0.2px;
  text-align: center;
  border-radius: 5px;
  color: ${({ theme }) => theme.lightBlue.a10};
  background-color: rgba(203, 227, 255, 0.5);
  margin-right: 5px;
`;

export const MenuBtn = styled(SvgIcon)`
  cursor: pointer;
  color: ${({ theme }) => theme.baseBlue.a10};
`;

export const EditFormContainer = styled.div<{ $timeout: number, $shouldAnimate: boolean }>`
  overflow: hidden;
  max-height: ${({ $shouldAnimate }) => $shouldAnimate ? '1000px' : '0'};
  transition: max-height ${({ $timeout }) => $timeout}ms;

  &.exit {
    max-height: 0;
  }

  &.enter-active,
  &.enter-done {
    max-height: 1000px;
  }
`;
